import React, { useState } from 'react'

import {
  ActivityIndicator,
  Button,
  Card,
  ProgressBar,
  Tag,
  TextField,
  Switch,
  Pager,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  IconNames
} from './lib'
import Color from './components/Color'

import * as variables from './lib/styles/_variables.scss'
import './lib/adl.scss'
import './App.scss'

function App() {
  const [checked, setChecked] = useState(true)

  return (
    <div className="container" style={{ padding: 80 }}>
      <h1>Alogent Design Library</h1>

      <hr />

      <div className="demo-page">
        <h2 style={{ marginBottom: 40 }}>Colors</h2>

        <h3>Brand Colors</h3>
        <div className="color-row">
          <Color
            name="Interactive"
            value={variables.colorInteractive}
            style={{ marginRight: 64 }}
          />
          <Color name="Primary" value={variables.colorPrimary} />
          <Color name="Secondary" value={variables.colorSecondary} />
        </div>

        <h3>Brand Gradients</h3>
        <div className="color-row">
          <Color
            name="Light"
            value={variables.gradientLight}
            swatchStyle={{
              backgroundImage: variables.gradientLight,
              border: '2px solid #444'
            }}
          />
          <Color
            name="Vivid"
            value={variables.gradientVivid}
            swatchStyle={{ backgroundImage: variables.gradientVivid }}
          />
        </div>

        <h3>System Utility</h3>
        <div className="color-row">
          <Color name="Black" value={'#000000'} />
          <Color
            name="White"
            value={'#ffffff'}
            swatchStyle={{ border: '2px solid #444' }}
          />
        </div>

        <h3>System Feedback</h3>
        <div className="color-row">
          <Color name="Success" value={variables.colorSuccess} />
          <Color name="Warning" value={variables.colorWarning} />
          <Color name="Danger" value={variables.colorDanger} />
        </div>

        <h3>System Grayscale</h3>
        <div className="color-row">
          <Color
            name="Gray 50"
            value={variables.colorGray50}
            swatchStyle={{ border: '2px solid #444' }}
          />
          <Color
            name="Gray 100"
            value={variables.colorGray100}
            swatchStyle={{ border: '2px solid #444' }}
          />
          <Color
            name="Gray 200"
            value={variables.colorGray200}
            swatchStyle={{ border: '2px solid #444' }}
          />
          <Color
            name="Gray 300"
            value={variables.colorGray300}
            swatchStyle={{ border: '2px solid #444' }}
          />
          <Color
            name="Gray 400"
            value={variables.colorGray400}
            swatchStyle={{ border: '2px solid #444' }}
          />
        </div>
        <div className="color-row">
          <Color name="Gray 500" value={variables.colorGray500} />
          <Color name="Gray 600" value={variables.colorGray600} />
          <Color name="Gray 700" value={variables.colorGray700} />
          <Color name="Gray 800" value={variables.colorGray800} />
          <Color name="Gray 900" value={variables.colorGray900} />
        </div>
      </div>

      <div className="demo-page">
        <h2>Shadows</h2>

        <div className="flex-row">
          <div className="card-shadow none">None</div>
          <div className="card-shadow small">Small</div>
          <div className="card-shadow medium">Medium</div>
          <div className="card-shadow large">Large</div>
          <div className="card-shadow huge">Huge</div>
        </div>
      </div>

      <div className="demo-page">
        <h2>Typography</h2>

        <div className="typography-parade">
          <h1 className="huge">Huge Heading</h1>
          <h1 className="big">Big Heading</h1>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <h4>Heading 4</h4>
          <h5>Heading 5</h5>
          <h6>Heading 6</h6>

          <p className="body large">Body Large (Lead)</p>

          <p className="body">Body</p>

          <p>
            <strong>Small:</strong>
          </p>
          <p className="small">
            This Agreement may be used for software interchange; or, b)
            Accompany it with the `Work' referring to freedom, not price. Our
            General Public License instead of this License, and (iii) describe
            the limitations and the like. Document File" shall mean any work
            that you distribute must include the following conditions are met:
            Redistributions of source code for a fee. You may add Your own
            attribution notices within Derivative Works that You distribute at
            least twelve (12) months after a new version of this License.
          </p>

          <p>
            <strong>Tiny:</strong>
          </p>
          <p className="tiny">
            This Agreement may be used for software interchange; or, b)
            Accompany it with the `Work' referring to freedom, not price. Our
            General Public License instead of this License, and (iii) describe
            the limitations and the like. Document File" shall mean any work
            that you distribute must include the following conditions are met:
            Redistributions of source code for a fee. You may add Your own
            attribution notices within Derivative Works that You distribute at
            least twelve (12) months after a new version of this License.
          </p>
        </div>
      </div>

      <div className="demo-page">
        <h2>Card</h2>

        <Card style={{ width: 320, height: 240 }}></Card>
      </div>

      <div className="demo-page">
        <h2>Buttons</h2>

        <Table style={{ textAlign: 'center' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'right' }}>Type</th>
              <th>Normal</th>
              <th>Hover</th>
              <th>Active</th>
              <th>Disabled</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Default
              </td>
              <td>
                <Button>Button</Button>
              </td>
              <td>
                <Button className="hover">Button</Button>
              </td>
              <td>
                <Button className="active">Button</Button>
              </td>
              <td>
                <Button disabled>Button</Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Interactive
              </td>
              <td>
                <Button color="interactive">Button</Button>
              </td>
              <td>
                <Button color="interactive" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="interactive" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="interactive" disabled>
                  Button
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Secondary
              </td>
              <td>
                <Button color="secondary">Button</Button>
              </td>
              <td>
                <Button color="secondary" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="secondary" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="secondary" disabled>
                  Button
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Dark
              </td>
              <td>
                <Button color="dark">Button</Button>
              </td>
              <td>
                <Button color="dark" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="dark" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="dark" disabled>
                  Button
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Destructive
              </td>
              <td>
                <Button color="destructive">Button</Button>
              </td>
              <td>
                <Button color="destructive" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="destructive" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="destructive" disabled>
                  Button
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Link
              </td>
              <td>
                <Button color="link">Button</Button>
              </td>
              <td>
                <Button color="link" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="link" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="link" disabled>
                  Button
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                Destructive Link
              </td>
              <td>
                <Button color="destructive-link">Button</Button>
              </td>
              <td>
                <Button color="destructive-link" className="hover">
                  Button
                </Button>
              </td>
              <td>
                <Button color="destructive-link" className="active">
                  Button
                </Button>
              </td>
              <td>
                <Button color="destructive-link" disabled>
                  Button
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="demo-page">
        <h2>Tag</h2>

        <div className="flex-row">
          <Tag color="interactive">Label</Tag>
          <Tag color="secondary">Label</Tag>
          <Tag color="light">Label</Tag>
          <Tag color="dark">Label</Tag>
        </div>
      </div>

      <div className="demo-page">
        <h2>Switch</h2>

        <Switch
          id="example-switch"
          value={checked}
          onChange={() => setChecked(!checked)}
        />
      </div>

      <div className="demo-page">
        <h2>Activity Indicator</h2>

        <ActivityIndicator />
      </div>

      <div className="demo-page">
        <h2>Progress Bar</h2>

        <ProgressBar value={50} />
      </div>

      <div className="demo-page">
        <h2>Pagination</h2>

        <Pagination aria-label="Page navigation example">
          <PaginationItem>
            <PaginationLink href="#">Prev</PaginationLink>
          </PaginationItem>
          <PaginationItem active>
            <PaginationLink href="#">1</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#">2</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#">3</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#">4</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#">5</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <PaginationLink href="#">Next</PaginationLink>
          </PaginationItem>
        </Pagination>
      </div>

      <div className="demo-page">
        <h2>Pager</h2>

        <Pager numPages={3} activePage={0} />
      </div>

      <div className="demo-page">
        <h2>Text Input</h2>

        <div style={{ maxWidth: 256 }}>
          <Card body>
            <TextField
              label="Username"
              placeholder="Placeholder text"
              helpText="Enter your username or email address."
              style={{ marginBottom: 8 }}
            />
            <TextField
              label="Username"
              placeholder="Placeholder text"
              helpText="Enter your username or email address."
              valid
              style={{ marginBottom: 8 }}
            />
            <TextField
              label="Username"
              placeholder="Placeholder text"
              value="fake_user"
              helpText="Enter your username or email address."
              errorText="This username could not be found."
              invalid
              style={{ marginBottom: 8 }}
            />
          </Card>
        </div>
      </div>

      <div className="demo-page">
        <h2>Icons</h2>

        <div className="flex-row">
          {IconNames.map(icon => (
            <div className="icon-presenter" key={icon}>
              <i className={icon} style={{ fontSize: 64 }} />
              <div className="code">
                <kbd>{icon}</kbd>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default App
